import React from "react";
import { Box, Stepper, Step, StepLabel, Paper } from "@mui/material";
import AccountForm from "./steps/AccountForm";
//import AccountListStep from "./steps/AccountListStep";
import ReviewPage from "./steps/ReviewPage";
import { bizpost } from "../../../ajax";

interface FetchParams {
  accountno: string;
  mobileno: string;
  networkid: string;
}

interface WizardState {
  activeStep: number;
  fetchParams: FetchParams;
  accounts: any[];
  selectedAccount: any | null;
  loading: boolean;
}

export default class RegistrationWizard extends React.Component<{}, WizardState> {
  state: WizardState = {
    activeStep: 0,
    fetchParams: {
      accountno: "",
      mobileno: "",
      networkid: ""
    },
    accounts: [],
    selectedAccount: null,
    loading: false
  };

  steps = [
    "Request",
    "Review",
    "Submit"
  ];

  handleNext = () =>
    this.setState(prev => ({ activeStep: prev.activeStep + 1 }));

  handleBack = () =>
    this.setState(prev => ({ activeStep: prev.activeStep - 1 }));

  handleParamsSubmit = async (params: any) => {
    try{
      this.setState({ loading: true });
      //const { accountno } = params;
      const conf = {s:'bankapi',a:'account',...params};
      const res = await bizpost(conf);
      const {success,data} = res;
      if(success){
        this.setState(
          { fetchParams: params },
          this.handleNext
        );
      }
    }
    catch(err){
      const bas:any = {};
      const msg = (err !== null && typeof err === 'object')?{...bas,...err}.message : String(err);
      console.log('param.submit.error',err);
    }
    finally{
      this.setState({ loading: false });
    }
  };

  fetchAccounts = async () => {
    const { fetchParams } = this.state;

    this.setState({ loading: true });

    //const query = new URLSearchParams(fetchParams).toString();

    // Replace with real API
    //const res = await fetch(`/api/accounts?${query}`);
    const params = {s:'bankapi',a:'momolink',...fetchParams}; //Object.assign(record,formdata,{s,a,ft,ms,mt});
    const res = await bizpost(params);
    //const data = await res.json();
    const {success,data} = res;

    this.setState({
      accounts: data,
      loading: false
    });
  };

  handleAccountSelect = (account: any) => {
    this.setState({ selectedAccount: account }, this.handleNext);
  };

  renderStepContent() {
    const { activeStep, accounts, selectedAccount } = this.state;

    switch (activeStep) {
      case 0:
        return (
          <AccountForm
            onSubmit={this.handleParamsSubmit}
          />
        );
      // case 1:
      //   return (
      //     <AccountListStep
      //       accounts={accounts}
      //       onLoad={this.fetchAccounts}
      //       onSelect={this.handleAccountSelect}
      //     />
      //   );
      case 2:
        return (
          <ReviewPage
            account={selectedAccount}
            onConfirm={this.handleNext}
          />
        );
      case 3:
        return <Box>✅ Registration Request Submitted</Box>;
      default:
        return null;
    }
  }

  render() {
    const { activeStep } = this.state;

    return (
      <Paper sx={{ p: 4, maxWidth: 720, mx: "auto" }}>
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
          {this.steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {this.renderStepContent()}
      </Paper>
    );
  }
}